module.exports = __webpack_public_path__ + "img/close-arrow-black.0d3eec51.svg";